import CreateHealthWorker from "./Create";

export default CreateHealthWorker;
